/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plancredits1Inputs */

const en_plancredits1 = /** @type {(inputs: Plancredits1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits`)
};

const de_plancredits1 = /** @type {(inputs: Plancredits1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits`)
};

/**
* | output |
* | --- |
* | "Credits" |
*
* @param {Plancredits1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const plancredits1 = /** @type {((inputs?: Plancredits1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plancredits1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plancredits1(inputs)
	return de_plancredits1(inputs)
});
export { plancredits1 as "planCredits" }